<template>
    <div class="top-table-filter-container">
        <!-- Десктопная версия -->
        <div class="d-none d-md-block">
            <div class="green-filter d-flex mb-2 align-items-center">
                <!-- Фильтр статусов -->
                <span v-for="(item, index) in statusFilterMenu" 
                    :key="index" 
                    class="mr-2"
                    :class="item.active ? 'green-link active' : 'green-link'" 
                    @click="changeStatusActive(index)">
                    {{ item.title }}
                </span>
            </div>
            <div class="green-filter d-flex mb-2 align-items-center">        
                <!-- Фильтр категорий -->
                <span v-for="(item, index) in categoryFilterMenu" 
                    :key="'cat-' + index" 
                    class="mr-2"
                    :class="item.active ? 'green-link active' : 'green-link'" 
                    @click="changeCategoryActive(index)">
                    {{ item.title }}
                </span>
            </div>
        </div>

        <!-- Мобильная версия -->
        <div class="d-flex d-md-none mobile-filter-container">
            <!-- Бургер-меню -->
            <button 
                class="burger-menu-btn"
                @click="toggleMobileMenu"
                :class="{ active: isMobileMenuOpen }"
            >
                <span class="burger-line"></span>
                <span class="burger-line"></span>
                <span class="burger-line"></span>
            </button>

            <!-- Выпадающее меню -->
            <div class="mobile-dropdown" :class="{ show: isMobileMenuOpen }">
                <div class="mobile-filter-section">
                    <h6 class="mobile-filter-title">Статус</h6>
                    <div class="mobile-filter-items">
                        <span 
                            v-for="(item, index) in statusFilterMenu"
                            :key="index"
                            :class="`mobile-filter-item ${item.active ? 'active' : ''}`"
                            @click="changeStatusActive(index); closeMobileMenu()"
                        >
                            {{ item.title }}
                        </span>
                    </div>
                </div>

                <div class="mobile-filter-section">
                    <h6 class="mobile-filter-title">Категория</h6>
                    <div class="mobile-filter-items">
                        <span 
                            v-for="(item, index) in categoryFilterMenu"
                            :key="'cat-' + index"
                            :class="`mobile-filter-item ${item.active ? 'active' : ''}`"
                            @click="changeCategoryActive(index); closeMobileMenu()"
                        >
                            {{ item.title }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        api: {type: String, required: true}, // Ссылка на API для работы с таблицей
    },
    data() {
        return {
            isMobileMenuOpen: false,
            statusFilterMenu: [
                {title: "Все статусы", value: "", active: true},
                {title: "Черновики", value: "draft", active: false},
                {title: "Опубликовано", value: "published", active: false},
                {title: "Запланировано", value: "scheduled", active: false},
                {title: "В архиве", value: "archived", active: false}
            ],
            categoryFilterMenu: [
                {title: "Все категории", value: "", active: true},
                {title: "Внутренние сотрудники", value: "internal_employees", active: false},
                {title: "B2B", value: "b2b", active: false},
                {title: "B2C", value: "b2c", active: false},
                {title: "Агенты", value: "agents", active: false},
                {title: "Клиенты", value: "clients", active: false}
            ]
        };
    },
    computed: {
        ...mapGetters("auth", ["currentUser"]),
    },    
    mounted() {
        // Восстанавливаем сохраненные фильтры
        const savedStatusIndex = this.$store.state.userLocalSettings.filterSettings.newsStatusTable || 0;
        const savedCategoryIndex = this.$store.state.userLocalSettings.filterSettings.newsCategoryTable || 0;
        
        this.changeStatusActive(savedStatusIndex);
        this.changeCategoryActive(savedCategoryIndex);
    },
    methods: {
        changeStatusActive(activeIndex) {
            // Сохраняем выбор в store
            this.$store.dispatch("userLocalSettings/SET_FILTER_SETTINGS", {
                name: 'newsStatusTable',
                value: activeIndex
            });

            // Обновляем активный статус в фильтре
            this.statusFilterMenu.forEach((item, index) => {
                item.active = activeIndex == index;
            });

            this.emitFilterChange();
        },
        
        changeCategoryActive(activeIndex) {
            // Сохраняем выбор в store
            this.$store.dispatch("userLocalSettings/SET_FILTER_SETTINGS", {
                name: 'newsCategoryTable',
                value: activeIndex
            });

            // Обновляем активную категорию в фильтре
            this.categoryFilterMenu.forEach((item, index) => {
                item.active = activeIndex == index;
            });

            this.emitFilterChange();
        },
        
        emitFilterChange() {
            let additionalParameter = '';

            // Добавляем параметр статуса
            const activeStatus = this.statusFilterMenu.find(item => item.active);
            if (activeStatus && activeStatus.value) {
                additionalParameter += `&status=${activeStatus.value}`;
            }

            // Добавляем параметр категории
            const activeCategory = this.categoryFilterMenu.find(item => item.active);
            if (activeCategory && activeCategory.value) {
                additionalParameter += `&category=${activeCategory.value}`;
            }

            this.$emit('setFilteringApiParameter', additionalParameter);
        },

        // Методы для мобильного меню
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
        },

        closeMobileMenu() {
            this.isMobileMenuOpen = false;
        }
    }
};
</script>
